export default __webpack_public_path__ + "images/logo.66f01661d1fcdc9cf738b77d8c081afb.png";